import React, { useEffect } from "react";
import Header from "./Header";
import "./FreeTrial.css";
import Footer from "./Footer";
import { Link } from "react-router-dom";

import logo from "./bluelogo.png";

import img1 from './freetrial__images/1.jpg'
import img2 from './freetrial__images/2.jpg'
import img3 from './freetrial__images/3.jpg'
import img4 from './freetrial__images/4.jpg'
import img5 from './freetrial__images/5.jpg'
import img6 from './freetrial__images/6.jpg'
import img7 from './freetrial__images/7.jpg'
import img8 from './freetrial__images/8.jpg'
import img9 from './freetrial__images/9.jpg'
import img10 from './freetrial__images/10.jpg'
import img11 from './freetrial__images/11.jpg'
import img12 from './freetrial__images/12.jpg'
import img13 from './freetrial__images/13.jpg'
import img14 from './freetrial__images/14.jpg'
import img15 from './freetrial__images/15.jpg'


import pdfsrc from "./freetrial__images/website-pdf.pdf";

function FreeTrial() {
  const onButtonClick = () => {
    const pdfUrl = pdfsrc; // Path to your PDF file
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "irregular-verbs-list.pdf"; // Specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const moreInfo = () => {
    alert("This course is still in development, please check back later.");
  };

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []);

  window.onscroll = function () {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");

    if (window.scrollY > 50) {
      // Change 30 to your desired scroll distance

      headerLogo.style.width = "60px";
      // header.style.padding = "10px 100px";
      header.style.transition = "background 0.3s ease-in-out";
    } else {
      if (window.innerWidth < "668") {
        headerLogo.style.width = "60px";
        header.style.background = "white";
        // header.style.padding = "20px 100px";
      } else {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      }
    }
  };
  useEffect(() => {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");
    headerLogo.style.width = "60px";
    header.style.background = "white";
    // header.style.padding = "20px 100px";
  }, []);
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  //

  document.body.style.background = "#f1f1f1";
  return (
    <div className="allCourses">
      <header id="All__courses__header">
        <a href="https://toustousacademy.com/">
          <img src={logo} alt="" />
        </a>
        <ul>
          <a href="/" onClick={scrollToTop}>
            <li>Home</li>
          </a>
          <a href="/#about">
            <li>About</li>
          </a>
          <a href="/#feedback">
            <li>Feedback</li>
          </a>
        </ul>
      </header>
      <div className="courses__container">
        <div className="free__course">
          <h2>Vocabulary Lessons</h2>
          <p dir="rtl" className="introduction__p">
            قبل أن تبدأ في مشاهدة شرح الدرس، من المهم جدًا أن تشاهد التقديم
            أولاً. التقديم سيساعدك على فهم الأفكار الأساسية والمفاهيم العامة
            التي ستسهل عليك متابعة الشرح بطريقة أكثر فعالية. باتباع هذا الترتيب،
            ستضمن فهمًا أعمق وأسهل للدرس وتحقيق أفضل النتائج.
          </p>

          <div className="img__title__container">
            <div className="course__img__title">
              <img src={img1} alt="" />
              <div className="courseTitle">Introduction to Vocabulary</div>
              <p className="arabic__p">تقديم حول محور المفردات</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">Unit 1</div>
                <Link to="/freetrial/vocabulary/introduction">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img2} alt="" />
              <div className="courseTitle">Gifts of youth</div>
              <p className="arabic__p">مواهب الشباب</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/vocabulary/gifts-of-youth">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img3} alt="" />
              <div className="courseTitle">Practice some exercises</div>
              <p className="arabic__p">ممارسة بعض التمارين</p>
              <div className="vocabulary__buttons">
                {/* <div class="toast" id="toast">
                  This is a toast notification!
                </div> */}
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/vocabulary/exercises">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="free__course">
          <h2>Functions Lessons</h2>
          {/* <p >
            قبل أن تبدأ في مشاهدة شرح الدرس، من المهم جدًا أن تشاهد التقديم
            أولاً. التقديم سيساعدك على فهم الأفكار الأساسية والمفاهيم العامة
            التي ستسهل عليك متابعة الشرح بطريقة أكثر فعالية. باتباع هذا الترتيب،
            ستضمن فهمًا أعمق وأسهل للدرس وتحقيق أفضل النتائج.
          </p> */}

          <div className="img__title__container">
            <div className="course__img__title">
              <img src={img4} alt="" />
              <div className="courseTitle">Introduction to Functions</div>
              <p className="arabic__p">تقديم حول وظائف اللغة</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">
                  Unit 1
                </div>
                <Link to="/freetrial/functions/introduction">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img5} alt="" />
              <div className="courseTitle">Expressing opinion</div>
              <p className="arabic__p">التعبير عن رأي.</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/functions/expressing-opinion">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img6} alt="" />
              <div className="courseTitle">Practice some exercises</div>
              <p className="arabic__p">ممارسة بعض التمارين</p>
              <div className="vocabulary__buttons">
                {/* <div class="toast" id="toast">
                  This is a toast notification!
                </div> */}
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/functions/exercises">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="free__course">
          <h2>Grammar Lessons</h2>
          {/* <p >
            قبل أن تبدأ في مشاهدة شرح الدرس، من المهم جدًا أن تشاهد التقديم
            أولاً. التقديم سيساعدك على فهم الأفكار الأساسية والمفاهيم العامة
            التي ستسهل عليك متابعة الشرح بطريقة أكثر فعالية. باتباع هذا الترتيب،
            ستضمن فهمًا أعمق وأسهل للدرس وتحقيق أفضل النتائج.
          </p> */}

          <div className="img__title__container">
            <div className="course__img__title">
              <img src={img7} alt="" />
              <div className="courseTitle">Introduction to Grammar</div>
              <p className="arabic__p">تقديم حول دروس القواعد</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">
                  Unit 1
                </div>
                <Link to="/freetrial/grammar/introduction">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img8} alt="" />
              <div className="courseTitle">Gerund and infinitive</div>
              <p className="arabic__p">اسم الفاعل والمصدر</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/grammar/Gerund-and-infinitive">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img9} alt="" />
              <div className="courseTitle">Practice some exercises</div>
              <p className="arabic__p">ممارسة بعض التمارين</p>
              <div className="vocabulary__buttons">
                {/* <div class="toast" id="toast">
                  This is a toast notification!
                </div> */}
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/grammar/exercises">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="free__course">
          <h2>Writing Lessons</h2>
          {/* <p >
            قبل أن تبدأ في مشاهدة شرح الدرس، من المهم جدًا أن تشاهد التقديم
            أولاً. التقديم سيساعدك على فهم الأفكار الأساسية والمفاهيم العامة
            التي ستسهل عليك متابعة الشرح بطريقة أكثر فعالية. باتباع هذا الترتيب،
            ستضمن فهمًا أعمق وأسهل للدرس وتحقيق أفضل النتائج.
          </p> */}

          <div className="img__title__container">
            <div className="course__img__title">
              <img src={img10} alt="" />
              <div className="courseTitle">Introduction to Writing</div>
              <p className="arabic__p">تقديم حول محور الرايتين</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">
                  Unit 1
                </div>
                <Link to="/freetrial/writing/introduction">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img11} alt="" />
              <div className="courseTitle">Descriptive paragraph</div>
              <p className="arabic__p">فقرة وصفية</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/writing/descriptive-paragraph">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img12} alt="" />
              <div className="courseTitle">Practice some exercises</div>
              <p className="arabic__p">ممارسة بعض التمارين</p>
              <div className="vocabulary__buttons">
                {/* <div class="toast" id="toast">
                  This is a toast notification!
                </div> */}
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/writing/exercises">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="free__course">
          <h2>Tenses Lessons</h2>
          {/* <p >
            قبل أن تبدأ في مشاهدة شرح الدرس، من المهم جدًا أن تشاهد التقديم
            أولاً. التقديم سيساعدك على فهم الأفكار الأساسية والمفاهيم العامة
            التي ستسهل عليك متابعة الشرح بطريقة أكثر فعالية. باتباع هذا الترتيب،
            ستضمن فهمًا أعمق وأسهل للدرس وتحقيق أفضل النتائج.
          </p> */}

          <div className="img__title__container">
            <div className="course__img__title">
              <img src={img13} alt="" />
              <div className="courseTitle">Introduction to Tenses</div>
              <p className="arabic__p">تقديم حول محور الأزمنة</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">
                  Unit 1
                </div>
                <Link to="/freetrial/tenses/introduction">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img14} alt="" />
              <div className="courseTitle">How to memorize irregular verbs</div>
              <p className="arabic__p">كيفية حفظ الأفعال الشادة</p>
              <div className="vocabulary__buttons">
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/tenses/irregular-verbs">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>

            <div className="course__img__title">
              <img src={img15} alt="" />
              <div className="courseTitle">Download irregular verbs list</div>
              <p className="arabic__p">تحميل قائمة الأفعال الشادة</p>
              <div className="vocabulary__buttons">
                {/* <div class="toast" id="toast">
                  This is a toast notification!
                </div> */}
                <div className="moreInfo">Unit 1</div>

                <Link to="/freetrial/tenses/irregular-verbs-pdf">
                  <button className="allCoursesGetStarted">Get started</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <center>
        <h1>Welcome to PDF Download Example</h1>
        <h3>Click the button below to download the PDF file</h3>
        <button onClick={onButtonClick}>Download PDF</button>
      </center> */}

      {/* <Footer /> */}
    </div>
  );
}

export default FreeTrial;
